/**
 * Faz scroll suave para o fim da lista de mensagens
 * @param {React.RefObject} lastMessageRef - Ref do último elemento
 */
export const scrollToBottom = (lastMessageRef) => {
  setTimeout(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }
  }, 100);
};

/**
 * Verifica se deve carregar mais mensagens baseado na posição do scroll
 * @param {number} scrollTop - Posição atual do scroll
 * @param {boolean} hasMore - Se há mais mensagens para carregar
 * @param {boolean} loading - Se está carregando
 * @param {Function} loadMore - Função para carregar mais
 */
export const handleScrollLoadMore = (scrollTop, hasMore, loading, loadMore) => {
  if (!hasMore) return;

  if (scrollTop === 0) {
    document.getElementById("messagesList").scrollTop = 1;
  }

  if (loading) {
    return;
  }

  if (scrollTop < 50) {
    loadMore();
  }
};
